import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import ForgotPasswordForm from "./ForgotPasswordForm";

type AuthView = "login" | "register" | "forgot-password";

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  defaultView?: AuthView;
  defaultEmail?: string;
  defaultFirstName?: string;
  defaultLastName?: string;
}

const AuthModal = ({ 
  isOpen, 
  onClose, 
  defaultView = "login", 
  defaultEmail = "",
  defaultFirstName = "",
  defaultLastName = ""
}: AuthModalProps) => {
  const [view, setView] = useState<AuthView>(defaultView);

  // Update view when defaultView changes
  useEffect(() => {
    if (isOpen) {
      setView(defaultView);
    }
  }, [isOpen, defaultView]);

  const handleSuccess = () => {
    onClose();
    setView("login");
  };

  const getTitle = () => {
    switch (view) {
      case "login":
        return "Inloggen";
      case "register":
        return "Account aanmaken";
      case "forgot-password":
        return "Wachtwoord resetten";
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!open) {
        onClose();
        setTimeout(() => setView("login"), 300);
      }
    }}>
      <DialogContent className="sm:max-w-md bg-card border-border">
        <DialogHeader>
          <DialogTitle className="text-xl font-display text-foreground">
            {getTitle()}
          </DialogTitle>
        </DialogHeader>

        <div className="py-4">
          {view === "login" && (
            <LoginForm
              onSuccess={handleSuccess}
              onSwitchToRegister={() => setView("register")}
              onForgotPassword={() => setView("forgot-password")}
            />
          )}
        {view === "register" && (
            <RegisterForm
              onSuccess={handleSuccess}
              onSwitchToLogin={() => setView("login")}
              defaultEmail={defaultEmail}
              defaultFirstName={defaultFirstName}
              defaultLastName={defaultLastName}
            />
          )}
          {view === "forgot-password" && (
            <ForgotPasswordForm
              onBack={() => setView("login")}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
